import { useState, useEffect } from 'react';
import { fetchAndProcessReviewData } from 'services/productDataService'; // Adjust path if needed
import { useNotifications } from 'context/NotificationContext'; // Import notification hook

export const useProductReviewData = ({ userId, orgId, selectedProducts, isRevenue, databaseMajorVersions }) => {
  const { addNotification } = useNotifications();

  const [processedData, setProcessedData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [comparisonErrors, setComparisonErrors] = useState([]);

  useEffect(() => {
    // Do nothing if there are no products to review.
    if (!selectedProducts || selectedProducts.length === 0) {
      setProcessedData([]);
      setLoading(false);
      setError(null);
      setComparisonErrors([]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      setComparisonErrors([]);

      try {
        const { data, errors, fetchErrors } = await fetchAndProcessReviewData({
          orgId,
          selectedProducts,
          isRevenue,
          databaseMajorVersions,
        });
        if (fetchErrors.length > 0) {
          // Use your notification system to inform the user
          fetchErrors.forEach((err) => {
            addNotification({
              title: ['Data Fetch Failed', err.endpoint],
              severity: 'warning',
              details: err.reason,
            });
          });
        }

        // Handle comparison errors
        if (errors.length > 0) {
          setComparisonErrors(errors);
          addNotification({
            title: ['Comparison Issues'],
            severity: 'warning',
            details: `${errors.length} product(s) could not be compared.`,
          });
        }

        console.log('[useProductReviewData] data', data);
        setProcessedData(data);
        if (errors.length > 0) {
          setComparisonErrors(errors);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId, orgId, selectedProducts, isRevenue, databaseMajorVersions, addNotification]);

  return { processedData, loading, error, comparisonErrors };
};
